import React from 'react'
import PropTypes from 'prop-types'
import TooltipComponent from '../utils/TooltipComponent'
import IconComponent from './IconComponent'
import ButtonComponent from './ButtonComponent'

const ClearButtonComponent = ({ onClick, children, disabled }) => {
  return (
    <TooltipComponent content="Clear" id="clear-tooltip" placement="bottom">
      <ButtonComponent type="button" color="danger mb-1" onClick={onClick} disabled={disabled}>
        <IconComponent icon="ant-design:clear-outlined" height="18" /> &nbsp;&nbsp;{children}
      </ButtonComponent>
    </TooltipComponent>
  )
}

ClearButtonComponent.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  children: PropTypes.node.isRequired,
}

export default ClearButtonComponent
